export default "__VITE_ASSET__BcNDjetI__"